import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';

export interface IConfirmDialogData {
  title: string;
  message: string;
  confirmText: string;
  confirmTooltip?: string;
  confirmDisabled?: boolean;
  cancelText: string;
  cancelTooltip?: string;
  cancelDisabled?: boolean;
  swapButtons: boolean;
  iconList?: { icon?: string; id: string; name: string }[];
}

@Component({
  imports: [MatDialogModule, MatButtonModule, IconBadgeComponent, MatTooltipModule],
  selector: 'app-confirm-dialog',
  styles: [
    `
      :host {
        mat-dialog-actions {
          padding: 0;
          padding-top: 16px;
        }

        mat-dialog-content {
          padding: 0;
          padding-top: 8px;
        }
      }
    `,
  ],
  template: `
    <div class="p-6">
      <span class="text-lg">{{ data.title }}</span>
      <mat-dialog-content>
        <p>{{ data.message }}</p>
        @if (data.iconList?.length) {
          <div class="flex flex-col gap-2 mt-4">
            @for (item of data.iconList; track item) {
              <div class="flex items-center gap-2">
                <app-icon-badge [content]="item.icon" [fallbackText]="item.name" [size]="24" [iconSize]="14" />
                <span>{{ item.name }}</span>
              </div>
            }
          </div>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="start">
        <div class="flex gap-2">
          @if (data.swapButtons) {
            <div class="flex items-center justify-center" [matTooltip]="data.cancelTooltip">
              <button
                mat-flat-button
                color="secondary"
                data-testid="confirm-dialog-cancel-button"
                [mat-dialog-close]="false"
                [disabled]="data.cancelDisabled"
              >
                {{ data.cancelText }}
              </button>
            </div>

            <div class="flex items-center justify-center" [matTooltip]="data.confirmTooltip">
              <button
                mat-flat-button
                color="danger"
                data-testid="confirm-dialog-confirm-button"
                [mat-dialog-close]="true"
                [disabled]="data.confirmDisabled"
              >
                {{ data.confirmText }}
              </button>
            </div>
          } @else {
            <div class="flex items-center justify-center" [matTooltip]="data.confirmTooltip">
              <button
                mat-flat-button
                color="danger"
                data-testid="confirm-dialog-confirm-button"
                [mat-dialog-close]="true"
                [disabled]="data.confirmDisabled"
              >
                {{ data.confirmText }}
              </button>
            </div>

            <div class="flex items-center justify-center" [matTooltip]="data.cancelTooltip">
              <button
                mat-flat-button
                color="secondary"
                data-testid="confirm-dialog-cancel-button"
                [mat-dialog-close]="false"
                [disabled]="data.cancelDisabled"
              >
                {{ data.cancelText }}
              </button>
            </div>
          }
        </div>
      </mat-dialog-actions>
    </div>
  `,
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData,
  ) {}
}
